import { saveEmployeeFilter } from "../../infrastructure/employees-filter";
import { displayCategoryEmployees } from "./displays/display-category-employees";

export async function findCategoryEmployees(category, value) {
  saveEmployeeFilter({ forState: category, searchString: value });

  displayCategoryEmployees({ category });
}
